import { Features } from '@ordersnproducts/features';
import { FeatureToggleActionTypes, FeatureToggleActions } from '../actions/feature-toggle.actions';

export interface FeatureToggleState {
  [Features.EnableContractDetail]: boolean;
}

export const initialState: FeatureToggleState = {
  [Features.EnableContractDetail]: true,
};

export function featureToggleReducer(state = initialState, action: FeatureToggleActions): FeatureToggleState {
  switch (action.type) {
    case FeatureToggleActionTypes.ENABLE_SHOW_CONTRACT: {
      return { ...state, ...action.payload };
    }
    default: {
      return state;
    }
  }
}
